import Links from '@/shared/constants/navegacao';
import { Column, DataTable } from '@/shared/components/tables/DataTable';
import { GetPredios } from '@/modules/structure/predio/predio.service';
import { Link } from 'react-router-dom';
import { ReadPredioDto } from '@/api.types';
import { toast } from 'react-toastify';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { useEffect, useState } from 'react';

export default function PredioIndex() {
  const { setActions } = useBreadcrumbActions();
  const [registros, setRegistros] = useState<[ReadPredioDto[], number]>();

  const tableState = useDataTableState('nome');

  const handleBuscar = () => {
    GetPredios((tableState.currentPage - 1) * tableState.pageSize, tableState.pageSize)
      .then((result) => {
        setRegistros([result.objects, result.count]);
      })
      .catch((res) => {
        toast.error(String(res) || '');
      });
  }

  useEffect(() => {
    handleBuscar();
  }, []);

  useEffect(() => {
    setActions({ primary: { label: 'Cadastrar', href: Links.Predio_Criar, onClick: () => { } } });
    return () => setActions({});
  }, [setActions]);

  let colunas: Column<ReadPredioDto>[] = [
    { key: "comarca.nome", header: "Comarca" },
    { key: "nome", header: "Local" },
    {
      key: "defensorias", header: "Defensorias/Núcleos",
      render: (row) => {
        return (<>{row.defensorias?.length} / {row.nucleos?.length} </>)
      }
    },
    { key: "endereco.bairro", header: "Bairro" },
    { key: "endereco.cep", header: "CEP" },
    { key: "telefoneprincipal.numero", header: "Telefone" },
    {
      key: "acoes", header: "Ações", render: (row) =>
        <Link className="link-secondary" to={Links.Predio_Editar + '/' + row.id}>
          Editar
        </Link>
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3>Unidades</h3>
          <span className="blockquote-footer pb-4 text-end">
            Prédios ou fóruns.
          </span>
        </div>
        <hr className="pb-4" />

        {registros &&
          <DataTable
            columns={colunas}
            data={registros[0]}
            initialSortKey='nome'
            onChange={handleBuscar}
            serverSide={true}
            states={tableState}
            totalRecords={registros[1]}
          />
        }

      </div>
    </>
  );
}
